export default __webpack_public_path__ + "christophe.d826b79.png";